import React, { useEffect, useState, useRef } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Table from 'react-bootstrap/Table';
import { Row, Col } from 'react-bootstrap';
import Carousel from 'react-bootstrap/Carousel';
import axios from 'axios';
import GenInstrusctionCBSE from './cbseApplication/GenInstructionCBSE';
import CBSEApplicationForm from './cbseApplication/CBSEApplicationForm';
import CBSEJobBannerCreator from './cbseApplication/CBSEJobBannerCreator';
import CBSEPrintView from './cbseApplication/CBSEPrintView';
import CBSEApplicationPrintView from './cbseApplication/CBSEApplicationPrintView';
import ShortlistedView from './cbseApplication/ShortlistedView';
const shortlistedData = {
  KINDERGARTEN: [
    { id: "26101", name: "AMALA MARY J" },
    { id: "26117", name: "JAINAF BEGAM M" },
    { id: "26120", name: "VINNARASI P" },
    { id: "26121", name: "T PHILIMINAL MARY" },
    { id: "26122", name: "R HEPSIBA" },
    { id: "26123", name: "A KARPAGA SELVI" },
    { id: "26125", name: "FEMINA STELLA D" },
    { id: "26127", name: "JOSELINE J" },
    { id: "26132", name: "INFANT JEANA S" },
    { id: "26141", name: "GOMATHI S" },
    { id: "26145", name: "I.GIRUBA MARY" },
    { id: "26150", name: "DONY SHAMINI B" },
    { id: "26155", name: "R. SHARMILA" },
    { id: "26156", name: "JOSEPHINE VITHYA" },
    { id: "26158", name: "SARA G" },
    { id: "26165", name: "JAYASRI C" },
    { id: "26168", name: "T CAROLIN DEVANASA OVIYA" },
    { id: "26171", name: "FATHIMA SAHAYA RANI A" },
    { id: "26183", name: "JULIET ROSLINE MARY S" }
  ],

  ENGLISH: [
    { id: "26306", name: "J. DAISY RANI" },
    { id: "26311", name: "DEVI K" },
    { id: "26314", name: "INFANT JENIFAR" },
    { id: "26318", name: "SNEHA MERY A" },
    { id: "26323", name: "RUTHPRAKASHI J" },
    { id: "26327", name: "CHITRA S" },
    { id: "26332", name: "SURUTHI S" },
    { id: "26335", name: "NIRMALA JESU F" },
    { id: "26336", name: "BACKIA LAKSHMI G M" },
    { id: "261003", name: "SILVIA A" },
    { id: "261009", name: "SNEHA SRI S" },
    { id: "261011", name: "RABIYATHUL BASARIYA M" },
    { id: "261021", name: "J. KIRUTHIGA" },
    { id: "261023", name: "SHARLIN R" },
    { id: "261026", name: "EDWIN GAVASKAR A" },
    { id: "261028", name: "C PRIYA" },
    { id: "261059", name: "SATHYA K" }
  ],

  TAMIL: [
    { id: "26203", name: "JULIET NIRMALA A" },
    { id: "26205", name: "A. SATHIA PRASANA" },
    { id: "26212", name: "NAGA R" },
    { id: "26214", name: "M.ANITHA" },
    { id: "26217", name: "PONNARASI P" },
    { id: "26223", name: "D.P. SAHAYA MARY CHITRA" },
    { id: "26224", name: "J SEBASTIAMMAL" },
    { id: "26901", name: "LORUDU MARY L" },
    { id: "26903", name: "KRISHNAMOORTHY S" },
    { id: "26906", name: "KANNIGADEVI K" },
    { id: "26908", name: "LYSA T" },
    { id: "26909", name: "JULIE MARY" },
    { id: "26910", name: "ANJALIDEVI G" },
    { id: "26916", name: "SAHAYA SELVARANI A" },
    { id: "26919", name: "JAISINGH A" },
    { id: "26922", name: "S DAVID VALLAVARAJ" },
    { id: "26929", name: "RUBIN CHRISTIAN RANI A" },
    { id: "26931", name: "S. RAMKI" },
    { id: "26932", name: "SHAKILA ANJALIN J" }
  ],

  MATHS: [
    { id: "26405", name: "CAROLINE RUBA S" },
    { id: "26407", name: "MONICA JOYCY J" },
    { id: "26413", name: "KAVIA L" },
    { id: "26415", name: "STELLA JEYASEELI A" },
    { id: "26421", name: "SELVI FATHIMARANI A" },
    { id: "26422", name: "SELVI N" },
    { id: "26423", name: "ANANTHI V" },
    { id: "26427", name: "SHANTHI P" },
    { id: "26430", name: "CHANDRASEKAR B" },
    { id: "26431", name: "HEMALATHA P" },
    { id: "26435", name: "K SUJATHA" },
    { id: "26437", name: "DISNEY RUTH L" },
    { id: "26444", name: "JANCY RANI" },
    { id: "26450", name: "JOHNSI RANI A" },

    { id: "261104", name: "NANCY INFANTA P" },
    { id: "261105", name: "LOUIS AKSHEELIA E" },
    { id: "261119", name: "RENIJA E" },
    { id: "261120", name: "SARATHA J" },
    { id: "261121", name: "G. QUEEN SHAYANE" },
    { id: "261123", name: "JELASDIN" },
    { id: "261124", name: "T. VALANARASU" },
    { id: "261125", name: "MYTHILY R" },
    { id: "261131", name: "SARAYU N" },
    { id: "261137", name: "XAVIER VINESH D E" },

    { id: "261139", name: "EPHREM WILFRED S" },
    { id: "261141", name: "JAISON AROCKIA RAJ S" },
    { id: "261149", name: "MERLYN M" },
    { id: "261154", name: "DIVYA EZHILARASI A" },
    { id: "261164", name: "V.G. LAKSHMI" },
    { id: "261167", name: "JACOBANTHONY" }
  ],

  EVS: [
    { id: "26504", name: "A. KARTHIKA" },
    { id: "26506", name: "JULIET SOPHIA MARY" },
    { id: "26509", name: "JOSEPH REVANTH" },
    { id: "26511", name: "VIJAYALAKSHMI P" },
    { id: "26516", name: "INIGO VALAN E" },
    { id: "26520", name: "B. JEYALAKSHMI" },
    { id: "26522", name: "EZHIL VANISHA J" },
    { id: "26525", name: "ARCHANA" },
    { id: "26531", name: "ANBARASI R" },
    { id: "26533", name: "VINNARASI X" },
    { id: "26541", name: "SUSMITHA X" },
    { id: "26549", name: "SANKAVI DEVI V" },
    { id: "26555", name: "S. NARMATHA" },
    { id: "26559", name: "SANGEETHA R" },
    { id: "26560", name: "ANGEL" }
  ],

  PHYSICAL_SCIENCE: [
    { id: "261201", name: "JEBA SHARMILA E" },
    { id: "261202", name: "ROSELINE KANISHKA S" },
    { id: "261209", name: "ANTONY BOSE X" },
    { id: "261214", name: "EZHIL VANISHA J" },
    { id: "261216", name: "PRINCY LOYOLA T" },
    { id: "261219", name: "ELIZABETHANANTHI A" },
    { id: "261222", name: "SELVAM GOVINDAN" },
    { id: "261223", name: "NAGAPANDI G" },
    { id: "261226", name: "JENIFFER RUBELLA J" }
  ],

  BIOLOGY: [
    { id: "261303", name: "SHABEENA M" },
    { id: "261306", name: "BAKIYA LAKSHMI K" },
    { id: "261309", name: "A. SARASWATHI" },
    { id: "261312", name: "RANJANI J" }
  ],

  SOCIAL_SCIENCE: [
    { id: "261401", name: "S SHANMUGA SELVI" },
    { id: "261402", name: "A THERASA" }
  ],

  COMPUTER_SCIENCE: [
    { id: "26601", name: "NIVETHA CHRISTY" },
    { id: "26602", name: "SRI DHARSHINI R" },
    { id: "26605", name: "ROBERT JONES S" },
    { id: "26606", name: "SURENDHAR A" },
    { id: "26608", name: "SUJITHRA SHEEBA J" },
    { id: "26615", name: "REVATHI J" },
    { id: "26617", name: "JAMUNA SALASIA MARY" },
    { id: "26624", name: "K. PREETHI" },
    { id: "26627", name: "M. SHOBANA DARATHI" },
    { id: "26628", name: "CHRISTY BASALICA S" },
    { id: "26629", name: "JENITHA MARY" },
    { id: "26630", name: "MEDOLIN REMA J" }
  ],

  HINDI: [
    { id: "26702", name: "S.K. AYESHA" },
    { id: "26704", name: "D PANDIAMMAL" },
    { id: "26705", name: "MYTHILY R" }
  ],

  ART: [
    { id: "26801", name: "SIBI S" },
    { id: "26802", name: "SHANMUGAPRIYA P" },
    { id: "26804", name: "A. REGINA MARY" }
  ],

  PET: [
    { id: "261602", name: "P SATHIYAVANI" },
    { id: "261603", name: "V. STELLAMARY" },
    { id: "261604", name: "VANITHA C" },
    { id: "261608", name: "REENA PRISKA D" },
    { id: "261611", name: "NITHYA JENSI RANI A" }
  ],

  COUNSELLING: [
    { id: "261504", name: "MEGHNA NISHA" },
    { id: "261507", name: "GAYATHRI T" },
    { id: "261513", name: "MARY SHALOM" },
    { id: "261515", name: "MARY SHILPA J" },
    { id: "261523", name: "SHARMILA" },
    { id: "261526", name: "JAYALAKSMI M" },
    { id: "261529", name: "G.B. AKSHAYA NIVEDA" }
  ]
};
//import Preloader from '../components/Preloader/Preloader';
//import JobBannerCreator from './JobBannerCreator';

const config = require('../../config.json');

export default function CBSERegistration() {
  const [acknowledged, setAcknowledged] = React.useState(false);
  const [activeKey, setActiveKey] = React.useState('shortlisted');
  const [dispMsg, setDispMsg] = React.useState('');
  const [loaded, setLoaded] = useState(true);
  const [openJobs, setOpenJobs] = useState([]);
  const applicationformRef = useRef(null);
  const formRef = useRef(null);
  const [selectedJob, setSelectedJob] = useState(null);

  useEffect(() => {
    //  fetchJobDetails();
    window.scrollTo(0, 0);
    return () => {
      console.log('Application unmounted');
    };
  }, []);

  /*const fetchJobDetails = async () => {
        try{
            setLoaded(false);
           // const { idToken } = (await fetchAuthSession()).tokens ?? {};
            const clientID='MDUEDN';
            const searchValue = 'Active';
            const searchTopic = 'PositionStatus';
            await axios.get(`${config.api.invokeURL}/school/jobs?fetchKey=${searchValue}&fetchOption=${searchTopic}&clientID=${clientID}`, {
            headers: {
             // Authorization: idToken,
              'x-api-key':config.api.key
            }
          }).then(async(response) => {
           console.log("response : ", response.data);
            if(response.data.length>0)
            {
                setOpenJobs(response.data);
              setLoaded(true);
            }
            //enqueueSnackbar(response.data.length + " - Staff's records found!",{variant:'success'}); 
            setLoaded(true);
        }).catch((error)=>{
          //enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
        setLoaded(true);
      })
    
        }catch(error){
          //enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
        setLoaded(true);
        }
      }*/

  const handleAcknowledge = (event) => {
    event.preventDefault();
    setAcknowledged(true);
    setActiveKey('registration');
    applicationformRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const handleSelect = (key) => {
    // If selecting registration without acknowledging, open instructions with friendly message
    if (key === "registration" && !acknowledged) {
      alert("Please read and acknowledge the instructions before proceeding to registration.");
      setActiveKey('instruction');
      return;
    }
    setActiveKey(key);
  };

  const handleRoute = (event, item) => {
    event.preventDefault();
    setSelectedJob(item);
    setAcknowledged(true);
    setActiveKey('registration');
    applicationformRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }

  return (
    <div className="container-fluid px-0">
      <Row id="jobopen" style={{ paddingLeft: '20px' }}>
        <h3 className="pt-3 fs-4 fs-md-3 mb-3 text-center w-100">Current Openings - Self Financed (CBSE)</h3>

        <CBSEJobBannerCreator handleRoute={handleRoute} />
      </Row>

      {dispMsg}
      <Row className='p-3 gx-3 gy-4' id="applicationform" ref={applicationformRef} >
        <Col xs={12}>
          <div className="d-flex flex-column justify-content-center align-items-center tab-content-responsive" style={{ minHeight: '60vh' }}>
            <Tabs
              activeKey={activeKey}
              onSelect={handleSelect}
              id="modern-tabs"
              className="mb-3 w-100 modern-tabs"
            >
              <Tab eventKey="registration" title="📝 Online Application" className="tab-pane-modern">
                <div>
                  <CBSEApplicationForm selectedJob={selectedJob} setActiveKey={setActiveKey} />
                </div>
              </Tab>
              <Tab eventKey="instruction" title="📋 Instructions & Eligibility" className="tab-pane-modern">
                <GenInstrusctionCBSE />
                <div style={{ marginTop: '20px', textAlign: 'center' }}>
                  <button className="btn btn-primary btn-modern" onClick={event => handleAcknowledge(event)}>
                    ✓ I have read and agree to proceed with Application
                  </button>
                </div>
              </Tab>
              <Tab eventKey="printapp" title="🖨️ Print / Track Application" className="tab-pane-modern">
                <div style={{ textAlign: "left" }}>
                  <CBSEPrintView dispMsg={dispMsg} setDispMsg={setDispMsg} openJobs={openJobs} />
                </div>
              </Tab>
              <Tab eventKey="shortlisted" title="🏆 Shortlisted Candidates" className="tab-pane-modern">
                <ShortlistedView data={shortlistedData} />
              </Tab>
            </Tabs>
          </div>
        </Col>
      </Row>
      <style>{`
        /* Modern Tab Styles */
        .modern-tabs .nav-tabs {
          border-bottom: none;
          gap: 10px;
          display: flex;
          background: #f8f9fa;
          padding: 12px;
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        }

        .modern-tabs .nav-link {
          background: white;
          border: 2px solid #e0e0e0;
          color: #666;
          border-radius: 8px;
          padding: 10px 20px;
          font-weight: 500;
          transition: all 0.3s ease;
          cursor: pointer;
          font-size: 14px;
        }

        .modern-tabs .nav-link:hover {
          border-color: #667eea;
          color: #667eea;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
        }

        .modern-tabs .nav-link.active {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          border-color: transparent;
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);
        }

        .modern-tabs .nav-link:disabled {
          background: #f5f5f5;
          color: #ccc;
          cursor: not-allowed;
          opacity: 0.5;
          border-color: #e0e0e0;
        }

        .modern-tabs .nav-link:disabled:hover {
          transform: none;
          box-shadow: none;
        }

        .tab-pane-modern {
          animation: fadeIn 0.3s ease-in;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(5px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .btn-modern {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: none;
          padding: 12px 30px;
          font-weight: 600;
          border-radius: 8px;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
        }

        .btn-modern:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 25px rgba(102, 126, 234, 0.4);
          background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
          color: white;
        }

        .btn-modern:active {
          transform: translateY(0);
        }

        .jobid-tag {
          display: inline-block;
          background: #e3f2fd;
          color: #1565c0;
          border-radius: 999px;
          padding: 0.35em 1.2em;
          font-size: 1rem;
          font-weight: 600;
          margin: 0.5em 0 0.5em 0;
          letter-spacing: 0.5px;
          box-shadow: 0 2px 8px 0 rgba(21,101,192,0.08);
        }
        @media (max-width: 991.98px) {
          .tab-content-responsive {
            padding: 0.5rem !important;
          }
          .fs-4 {
            font-size: 1.2rem !important;
          }
          .modern-tabs .nav-link {
            padding: 8px 16px;
            font-size: 13px;
          }
        }
        @media (max-width: 767.98px) {
          .tab-content-responsive {
            padding: 0.25rem !important;
          }
          .fs-4 {
            font-size: 1.1rem !important;
          }
          .img-fluid {
            border-radius: 0 !important;
          }
          .modern-tabs .nav-tabs {
            flex-wrap: wrap;
            gap: 8px;
            padding: 10px;
          }
          .modern-tabs .nav-link {
            padding: 8px 14px;
            font-size: 12px;
            flex: 1;
            min-width: 100px;
          }
        }
        @media (max-width: 575.98px) {
          .tab-content-responsive {
            padding: 0 !important;
          }
          .fs-4 {
            font-size: 1rem !important;
          }
          .img-fluid {
            border-radius: 0 !important;
          }
          .mb-4 {
            margin-bottom: 1rem !important;
          }
          .modern-tabs .nav-tabs {
            flex-wrap: wrap;
            gap: 6px;
            padding: 8px;
          }
          .modern-tabs .nav-link {
            padding: 6px 12px;
            font-size: 11px;
          }
          .btn-modern {
            padding: 10px 20px;
            font-size: 13px;
          }
        }
      `}</style>
    </div>
  )
}